import React, { useEffect, useState } from 'react';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import { openAttachment, dataUrlToBlobUrl } from '../../utils/encodeImageFile';

// The browser's PDF viewer in a frame. A saved attachment loads from its URL;
// one that is still local (a data URL) is shown through a temporary blob URL,
// since browsers won't load a data URL in a frame.
export const PdfPreviewFrame = ({ url, name }) => {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    if (!`${url}`.startsWith('data:')) {
      setSrc(url);
      return undefined;
    }

    const blobUrl = dataUrlToBlobUrl(url);
    setSrc(blobUrl);
    return () => URL.revokeObjectURL(blobUrl);
  }, [url]);

  if (!src) return null;

  return (
    <iframe
      className="pdf-preview-frame"
      title={`Preview of ${name || 'PDF attachment'}`}
      src={`${src}#toolbar=0&navpanes=0`}
      loading="lazy"
    />
  );
};

// A PDF attached to a report note: a file row that opens the PDF in a new
// tab. PDFs are stored as PDFs, so they aren't drawn inline like photos.
const PdfAttachment = ({ url, name }) => (
  <div className="pdf-attachment">
    <PictureAsPdfOutlinedIcon className="pdf-attachment-icon" />
    <span className="pdf-attachment-name">{name || 'PDF attachment'}</span>
    <button
      type="button"
      className="pdf-attachment-open"
      onClick={(e) => {
        e.stopPropagation();
        openAttachment(url);
      }}
    >
      <OpenInNewRoundedIcon />
      Open
    </button>
  </div>
);

export default PdfAttachment;
